import { handleApi } from "./common";

export const ACCOUNT_CLOSURE_API_CONSTANTS = {
  details: "/api/equity/api/eqm/account/closure/get/details",
  preCheck: "/api/equity/eqm/account/closure/precheck",
  triggerOtp: "/api/equity/account/closure/otp/trigger",
  verifyOtp: "/api/equity/account/closure/otp/",
  createEsignRequest: "/api/fury/relay/esign/request/create",
  closurePdfForm: "/api/fury/relay/esign/get/physical_form/",
};

export const fetch_pre_check = async (Api, token) => {
  const url = ACCOUNT_CLOSURE_API_CONSTANTS.preCheck;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_details = async (Api, data, token) => {
  const url = ACCOUNT_CLOSURE_API_CONSTANTS.details;
  const response = await Api.get(url, data, {}, token);
  return handleApi(response);
};

export const trigger_otp = async (Api, token) => {
  const url = ACCOUNT_CLOSURE_API_CONSTANTS.triggerOtp;
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const verify_otp = async (Api, url, data, token = "") => {
  const response = await Api.post(url, data, {}, token);
  return handleApi(response);
};

export const resend_otp = async (Api, url, token) => {
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const create_esign_request = async (Api, data, token) => {
  const url = ACCOUNT_CLOSURE_API_CONSTANTS.createEsignRequest;
  const response = await Api.post(url, data, {}, token);
  return handleApi(response);
};

export const fetch_esign_file_link = async (Api, url, token) => {
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};
